import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    loadingLabel: string;
    backLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label displayed while content is loading */
            loadingLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExportLocation.loadingLabel?c=2z6x46esp49fs", defaultMessage: "Loading content..." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the back button */
            backLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExportLocation.backLabel?c=2hodk36htwsl", defaultMessage: "Go back" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
